import React from 'react';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import { useIntl } from 'react-intl';

import RichText from '../../../UI/RichText';
import TextLink from '../../../UI/TextLink/TextLink';
import Image from '../../../UI/Image/Image';
import openChatWidget from '../../../../utils/openChatWidget';
import generateCssClassName from '../../../../utils/generateCssClassName/generateCssClassName';
import isKiosk from '../../../../utils/isKiosk';
import { Contentful, ContentType } from '../../../../types';
import extractArrayData from '../../../../utils/extractArrayData';

import {
  NoResultsContainer,
  MessageBox,
  Box,
  Message,
  MessageTitle,
  ChatButton,
} from './styles';

interface Props {
  standardNoResults: Record<string, any>;
}

const headingOptions = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => (
      <MessageTitle data-testid="filter-error-heading">
        {children}
      </MessageTitle>
    ),
  },
};
const bodyOptions = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => (
      <Message data-testid="filter-error-body">{children}</Message>
    ),
    [INLINES.EMBEDDED_ENTRY]: (node, { locale } = useIntl()) => (
      <TextLink
        route={node.data.target.ctaTarget}
        url={node.data.target.ctaUrl}
        linkText={node.data.target.ctaLabel.ctaLabel}
        locale={locale}
      />
    ),
  },
};

const FilterError = ({ standardNoResults }: Props) => {
  const isKioskMode = isKiosk();

  const heading = extractArrayData(
    standardNoResults?.combinatorSectionItems,
    Contentful.ContentfulId,
    '42cWrvv1DsEV7Vs10uWFDK',
  );

  const body = extractArrayData(
    standardNoResults?.combinatorSectionItems,
    Contentful.ContentfulId,
    '4L1EgAeNezKqRMAl05ozgY',
  );

  const cards = extractArrayData(
    standardNoResults?.combinatorSectionItems,
    Contentful.TypeName,
    ContentType.ContentfulCardItem,
  );

  return (
    <NoResultsContainer id="errorMsg" data-testid="filter-error-container">
      <MessageBox>
        <RichText document={heading?.heading} options={headingOptions} />
        {!isKioskMode && (
          <RichText document={body?.contentBody} options={bodyOptions} />
        )}
        <Box
          className={generateCssClassName(
            cards?.cardItemHideOption,
            isKioskMode,
          )}
        >
          {cards?.cardCta?.ctaIconDam && (
            <ChatButton
              type="button"
              aria-label={cards.cardCta.ctaAriaLabel}
              onClick={openChatWidget}
              data-testid="filter-error-chat-button"
            >
              <Image
                image={cards.cardCta.ctaIconDam}
                alt={cards.cardCta.ctaIconDam.altText}
                isImageDecorative
              />
            </ChatButton>
          )}
        </Box>
      </MessageBox>
    </NoResultsContainer>
  );
};

export default FilterError;
